export enum Gender {
	'Homme',
	'Femme',
	'Gender-fluid',
	'Non Binaire',
	'Agender',
	'Intersex',
	'Autre genre',
}

export const Gender2LabelMapping: Record<number, string> = {
	[Gender.Homme]: 'Homme',
	[Gender.Femme]: 'Femme',
	[Gender['Gender-fluid']]: 'Gender-fluid',
	[Gender['Non Binaire']]: 'Non Binaire',
	[Gender.Agender]: 'Agender',
	[Gender.Intersex]: 'Intersex',
	[Gender['Autre genre']]: 'Autre genre'
};

export enum Astro {
	'Aries',
	'Taurus',
	'Gemini',
	'Cancer',
	'Leo',
	'Virgo',
	'Libra',
	'Scorpio',
	'Sagittarius',
	'Capricorn',
	'Aquarius',
	'Pisces'
}

export const Astro2LabelMapping: Record<number, string> = {
	[Astro.Aries]: 'Aries',
	[Astro.Taurus]: 'Taurus',
	[Astro.Gemini]: 'Gemini',
	[Astro.Cancer]: 'Cancer',
	[Astro.Leo]: 'Leo',
	[Astro.Virgo]: 'Virgo',
	[Astro.Libra]: 'Libra',
	[Astro.Scorpio]: 'Scorpio',
	[Astro.Sagittarius]: 'Sagittarius',
	[Astro.Capricorn]: 'Capricorn',
	[Astro.Aquarius]: 'Aquarius',
	[Astro.Pisces]: 'Pisces'
};

export enum Role {
	'Dominant(e)',
	'Soumis(e)',
	'Switch',
}

export const Role2LabelMapping: Record<number, string> = {
	[Role['Dominant(e)']]: 'Dominant(e)',
	[Role['Soumis(e)']]: 'Soumis(e)',
	[Role.Switch]: 'Switch'
};

export enum Orientation {
	'Hétérosexuel(le)',
	'Lesbienne',
	'Gay',
	'Bisexuel(le)',
	'Queer',
	'Pansexue(le)',
	'Demisexuel(le)',
	'Asexuel(le)',
	'Autre orientation'
}

export const Orientation2LabelMapping: Record<number, string> = {
	[Orientation['Hétérosexuel(le)']]: 'Hétérosexuel(le)',
	[Orientation.Lesbienne]: 'Lesbienne',
	[Orientation['Bisexuel(le)']]: 'Bisexuel(le)',
	[Orientation.Queer]: 'Queer',
	[Orientation['Pansexue(le)']]: 'Pansexue(le)',
	[Orientation['Demisexuel(le)']]: 'Demisexuel(le)',
	[Orientation['Asexuel(le)']]: 'Asexuel(le)',
	[Orientation['Autre orientation']]: 'Autre orientation',
	[Orientation.Gay]: 'Gay'
};

export enum Search {
	'Virtuel',
	'Reel',
	'Amour',
	'Bdsm',
	'Seances',
	'Amitie',
}

export const Search2LabelMapping: Record<number, string> = {
	[Search.Virtuel]: 'Virtuel',
	[Search.Reel]: 'Réel',
	[Search.Amour]: 'Amour',
	[Search.Bdsm]: 'Bdsm',
	[Search.Seances]: 'Séances',
	[Search.Amitie]: 'Amitié'
};

export enum Status {
	'Celibataire',
	'Pris(e)',
	'Complique',
	'Relation ouverte',
	'Poly ouvert(e)',
	'Poly fermé(e)'
}

export const Status2LabelMapping: Record<number, string> = {
	[Status.Celibataire]: 'Célibataire',
	[Status['Pris(e)']]: 'Pris(e)',
	[Status.Complique]: 'Compliqué',
	[Status['Relation ouverte']]: 'Relation ouverte',
	[Status['Poly ouvert(e)']]: 'Poly ouvert(e)',
	[Status['Poly fermé(e)']]: 'Poly fermé(e)'
};

export enum SubscriptionType {
	'Classique',
	'Soutient',
	'Premium',
	'Eternal'
}

export enum Pronouns {
	'He/Him',
	'She/Her',
	'They/Them',
	'It/It\'s',
	'All Pronouns',
	'Other pronouns',
	'Ask my pronouns'
}

export const Pronouns2LabelMapping: Record<number, string> = {
	[Pronouns['He/Him']]: 'He/Him',
	[Pronouns['She/Her']]: 'She/Her',
	[Pronouns['It/It\'s']]: 'It/It\'s',
	[Pronouns['They/Them']]: 'They/Them',
	[Pronouns['All Pronouns']]: 'All Pronouns',
	[Pronouns['Other pronouns']]: 'Other pronouns',
	[Pronouns['Ask my pronouns']]: 'Ask my pronouns'
};
